import Permissions from '@/common/permissions';
import { useHasAccess } from '@/modules/core';

export const useHasAccessToViewBeneficiaries = () => useHasAccess([{ permission: Permissions.VIEW_PROFILE }]);
export const useHasAccessToEditBeneficiaries = () => useHasAccess([{ permission: Permissions.MODIFY_BENEFICIARY }]);
